<script setup lang="ts">
const SaleItems = () => import('@/components/organisms/SaleItems.vue')
const BuyConfirmationModal = () => import('@/components/molecules/BuyConfirmationModal.vue')
const PickupBannerSwipe = () => import('@/components/molecules/PickupBannerSwipe.vue')
import PpdSaleItemsData from '@/static/ppdSaleItemsData.json'
import PpdSaleItemsBannerData from '@/static/banner/data/PpdSaleItemsBanner.json'
import { useNuxtApp } from '@nuxt/bridge/dist/runtime'
import { ref, onBeforeMount, computed } from 'vue'
import { useAddressStore } from '@/stores/useAddressStore'
import { usePhoneNumberStore } from '@/stores/usePhoneNumberStore'

// Nuxt
const nuxtApp = useNuxtApp()
const { nuxt2Context, $toast,$router }: any = nuxtApp
const { $ppdService, $usersService, localePath } = nuxt2Context
const isLoading = ref(true)
const isBuyConfirmationModalShown = ref(false)
const actionId = ref(0)
const isDuplicationError = ref(false)
const phoneVerifyStatus = ref(0)
const ppdLimitedSaleStatusInfos = ref([])
const ppdSaleItemsData = PpdSaleItemsData
const banners = PpdSaleItemsBannerData

// 1: 初心者セット
// 2: ランドボリューム
const buyActions = {
  1: () => $ppdService.purchasePpdBeginnerSet(),
  2: () => $ppdService.purchasePpdLandVolume(),
  3: () => $ppdService.purchasePpdExtendPartySlot(),
  4: () => $usersService.purchasePrimeGiftCode(),
  5: () => $usersService.purchaseTenPrimeGiftCode(),
  6: () => $ppdService.purchasePpdUnit(4119),
  7: () => $ppdService.purchasePpdUnit(4120),
  8: () => $ppdService.purchasePpdUnit(5206),
  9: () => $ppdService.purchasePpdLandVolume2(),
}

onBeforeMount(async () => {
  ppdLimitedSaleStatusInfos.value = await $ppdService.getUserPpdRecordStatusInfos()
  await fetchDidVerifyPhone()
  isLoading.value = false
})

// Computed
const buyConfimationModalObj = computed(() => {
  return { ...ppdSaleItemsData.find(item => item.id == actionId.value) }
})


// Method
async function buy() {
  isLoading.value = true
  isBuyConfirmationModalShown.value = false
  try {
    await buyActions[actionId.value]()

    await useAddressStore().fetchPpdInfo()
    ppdLimitedSaleStatusInfos.value = await $ppdService.getUserPpdRecordStatusInfos()
    $toast.success('Success.')
    if(actionId.value == 4 || actionId.value == 5) {
      $router.push(
      localePath({
        path: '/prime/giftcodehistory',
      })
    )
    }
  } catch (e) {
    console.log(e)
    $toast.error(e.message)
  }
  isLoading.value = false
}

async function fetchDidVerifyPhone() {
  try {
    await usePhoneNumberStore().fetchValidatePhoneNumber()
    phoneVerifyStatus.value = usePhoneNumberStore().getPhoneVerifyStatus
  } catch (e) {
    if (e.message.includes('duplicate phone number')) {
      isDuplicationError.value = true
      phoneVerifyStatus.value = 4
    }
  }

  switch (phoneVerifyStatus.value) {
    default:
    case 0: // 電話未認証
    case 1: // 正常電話認証済み
    case 2: // prime加入済み(複アカprime加入なし)
      isDuplicationError.value = false
      break

    case 3: // prime未加入（複アカでprime加入あり)
    case 4: // 複アカありでプライム加入２つ以上あり(バン対象)
      isDuplicationError.value = true
      break
  }
}

function action(id: number) {
  actionId.value = id
  isBuyConfirmationModalShown.value = true
}

</script>

<template>
  <div>
    <div v-if="isLoading" class="grid place-items-center mt-4">
      <fa-icon :icon="['fal', 'spinner']" spin size="3x" />
    </div>
    <div v-else>
      <br>
      <PickupBannerSwipe :bannerData="banners" />
      <SaleItems class="mt-2" :limitedSaleStatusInfos="ppdLimitedSaleStatusInfos" :saleItems="ppdSaleItemsData"
        @action="action" />
    </div>
    <BuyConfirmationModal v-if="isBuyConfirmationModalShown" :obj="buyConfimationModalObj" :mode="'ppd'"
      @modal-close="isBuyConfirmationModalShown = false" @buy="buy"
      :alreadyPurchased="!!ppdLimitedSaleStatusInfos.find(info => info.recordType == buyConfimationModalObj.recordType)?.status"
      :isDuplicationError="isDuplicationError" />
  </div>
</template>
